import { FC, useEffect } from 'react';

type OnLayoutProps = {
  onLayout: (mounted: boolean) => void;
};

export const OnLayout: FC<OnLayoutProps> = ({ onLayout }) => {
  useEffect(() => {
    onLayout(true);

    return () => onLayout(false);
  }, [onLayout]);

  return null;
};
